"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FixedCover = /*#__PURE__*/function () {
  function FixedCover(elementId, staticCover) {
    var _this = this;
    _classCallCheck(this, FixedCover);
    this.staticCover = staticCover ? $('#' + staticCover) : $('section.cover');
    this.fixedCover = $('#' + elementId);
    this.resizeTimeout;
    this.windowScrollTop;
    this.window = $(window);
    this.windowResize = $(window).width();
    this.bgVerticalPosition = this.fixedCover.data('imagePositionHorizontal') ? this.fixedCover.data('imagePositionHorizontal') : 50;
    this.initialData();
    this.window.resize(function () {
      if (_this.resizeTimeout) {
        clearTimeout(_this.resizeTimeout);
      }
      _this.resizeTimeout = setTimeout(function () {
        if (_this.window.width() != _this.windowResize) {
          _this.initialData();
          _this.setFixedCoverPosition();
        }
      }, 300);
    });
    this.window.scroll(function () {
      _this.setFixedCoverPosition();
    });
    this.getDataFromCover();
    this.setFixedCoverPosition();
  }
  return _createClass(FixedCover, [{
    key: "initialData",
    value: function initialData() {
      this.navbarHeight = $('header').outerHeight(true);
      this.staticCoverHeight = this.staticCover.outerHeight(true);
      var templateId = $('body').data('template');
      switch (templateId) {
        case 'ebooks':
          this.fixedCoverPositionFromTop = this.staticCover.offset().top - this.navbarHeight;
          break;
        default:
          this.fixedCoverPositionFromTop = this.staticCoverHeight + this.staticCover.offset().top - this.navbarHeight;
          break;
      }
    }
  }, {
    key: "getDataFromCover",
    value: function getDataFromCover() {
      var titleStaticCover = $('.page-title > strong', this.staticCover).text();
      var imageStaticCover = this.staticCover.css('background-image');
      var titleFixedCover = $('div.title', this.fixedCover);
      titleFixedCover.text(titleStaticCover);
      this.fixedCover.css({
        'background-image': imageStaticCover,
        'backgroundPosition': '50%' + this.bgVerticalPosition + '%'
      });
    }
  }, {
    key: "setFixedCoverPosition",
    value: function setFixedCoverPosition() {
      this.windowScrollTop = this.window.scrollTop();
      //if(this.windowScrollTop > this.fixedCoverPositionFromTop) {
      if (this.windowScrollTop > this.fixedCoverPositionFromTop - this.navbarHeight) {
        this.fixedCover.addClass('active');
      } else {
        this.fixedCover.removeClass('active');
      }
    }
  }]);
}();